module.exports = __webpack_public_path__ + "static/media/marker_bus_stop_hover.b6b4c08a.svg";